/********************************************************************************
Filename: np-list-item.js
Created: 02 Feb 2021
Author: Ron Robertson
Description: Displays a list item. Can be used with "np-list" web component
CSS Custom Properties:
--label-width = the width of the label (default = 30%)
--desc-width: = the width of the description text (default = 70%)
Usage example:
    <np-list title='My Title'>
        <np-list-item label='My Label'>
            My list description goes here
        </np-list>
    </np-list>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #np-list-item{
                display:flex;
                flex-direction:column;
                justify-items: space-between;

                padding-bottom:32px;
                margin-top:32px;
            }
            #label{
                margin:0 0 10px 0;
                border-bottom: 1px solid #b8b7b3;
                font-family:var(--label-fontFamily, var(--semiBoldFontFamily));
                font-size:var(--label-fontSize, 24px);
                font-weight:normal;
            }
            #desc{
                color:#858585;
                line-height:135%;
                font-family:var(--bodyFontFamily);
                font-size:var(--bodyFontSize);
            }
            @media screen and (min-width: 768px) {
                #np-list-item{
                    flex-direction:row;
                    border-bottom: 1px solid #b8b7b3;
                    padding-bottom:50px;
                    margin-top:50px;
                }
                :host(:last-child) #np-list-item{
                    border-bottom: none;
                }
                #label{
                    margin:0;
                    width: var(--label-width, 30%);
                    padding-right:10px;
                    border-bottom: none;
                }
                #desc{
                    width: var(--desc-width, 70%);
                    padding-left:10px;
                }
            }


            :host(.scrollAnimate) #np-list-item {
                animation-duration: 1s;
                animation-fill-mode: forwards;
            }

            :host(.scrollAnimate.animate) #np-list-item {
                animation-name: contentInBottom;
            }

            /* Content sliding into view */
            @keyframes contentInBottom {
                0% {opacity:0; transform: translateY(30px);}
                100% {opacity:1; transform: translateY(0px);}
            }

        </style>

        <div id="np-list-item">
            <div id="label">
                <slot name="label"></slot>
            </div>
            <div id="desc">
                <slot></slot>
            </div><!--END desc-->
        </div><!--END np-list-item-->
    `;

    class NpListItem extends HTMLElement {
      constructor() {

        /* Always call super first in constructor */
        super();

        /* Activate the Shadow DOM */
        this.attachShadow({mode: 'open'});

        /* Attach template to DOM */
        this.shadowRoot.appendChild(template.content.cloneNode(true));

      } /* END constructor */


    } /* END class */

    /* Export the class */
    window.customElements.define('np-list-item', NpListItem);

  })();
